import React, { useContext } from "react";

export const ConfigContext = React.createContext<WebConfig>({
  graphqlAPI: "",
  appUrl: "",
  identityUrl: "",
  rudderstackURL: "",
  rudderstackWriteKeyWebApp: "",
  revision: "",
  oauthAppleRedirectUrl: "",
  oauthGoogleRedirectUrl: "",
  oauthLinkedinRedirectUrl: "",
  oauthMicrosoftRedirectUrl: "",
  oauthMicrosoftClientId: "",
  API: "",
  environment: "",
  growthbookKey: "",
  googleApiKey: "",
});
export interface WebConfig {
  graphqlAPI: string;
  appUrl: string;
  identityUrl: string;
  rudderstackURL: string;
  rudderstackWriteKeyWebApp: string;
  revision: string;
  oauthAppleRedirectUrl: string;
  oauthGoogleRedirectUrl: string;
  oauthLinkedinRedirectUrl: string;
  oauthMicrosoftRedirectUrl: string;
  oauthMicrosoftClientId: string;
  API: string;
  environment: string;
  growthbookKey: string;
  googleApiKey: string;
}

export const useConfig = () => useContext(ConfigContext);
